Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NormalizedScriptLocatorHTTPMethod () {
        return NormalizedScriptLocatorHTTPMethod;
    },
    get NormalizedScriptLocatorSignatureVerificationMode () {
        return NormalizedScriptLocatorSignatureVerificationMode;
    },
    get default () {
        return _default;
    }
});
var _reactnative = require("react-native");
var NormalizedScriptLocatorHTTPMethod = /*#__PURE__*/ function(NormalizedScriptLocatorHTTPMethod) {
    NormalizedScriptLocatorHTTPMethod["GET"] = "GET";
    NormalizedScriptLocatorHTTPMethod["POST"] = "POST";
    return NormalizedScriptLocatorHTTPMethod;
}({});
var NormalizedScriptLocatorSignatureVerificationMode = /*#__PURE__*/ function(NormalizedScriptLocatorSignatureVerificationMode) {
    NormalizedScriptLocatorSignatureVerificationMode["STRICT"] = "strict";
    NormalizedScriptLocatorSignatureVerificationMode["LAX"] = "lax";
    NormalizedScriptLocatorSignatureVerificationMode["OFF"] = "off";
    return NormalizedScriptLocatorSignatureVerificationMode;
}({});
var _default = _reactnative.TurboModuleRegistry.get('ScriptManager');
